import { useDocument } from 'react-firebase-hooks/firestore';
import { useEffect, useMemo, useRef, useState } from 'react';

// @mui
import { Button } from '@mui/material';


import { DateTime } from 'luxon';
import SpotifyService from '../services/spotify.service';
import HTTPService from '../services/httpservice';
import CheckinsService from '../services/checkins.service';
import TrackInfo from '../sections/@dashboard/info/TrackInfo';
import Iconify from '../components/iconify/Iconify';
import { NGROK_REDIRECT_URL, generateRandomString, isLocalhost } from '../App';

export default function DJDashboard(props) {

    const currentDay = DateTime.local().startOf('day')
    const [spotifyToken, loadingToken, errorGetTOken] = useDocument(CheckinsService.getSpotifyAuthToken())
    const [token, setToken] = useState('');
    const [track, setTrack] = useState({});
    const [newTrackCountdown, setnewTrackCountdown] = useState(100);
    const [lyrics, setLyrics] = useState('');
    const newTrackTimer = useRef()
  


    useEffect(() => {

        if (token && newTrackCountdown >= 0) {
          // console.log('token', token);
    
          if (newTrackTimer.current) clearTimeout(newTrackTimer.current)
    
          newTrackTimer.current = setTimeout(() => {
    
            const sps = new SpotifyService()
            console.log('getting song info');
            sps.getPlayingTrack(token).then(async song => {
    
              // setTrackinfo(JSON.stringify(r))
              if (song && song.item) {
                setTrack(song)
                // console.log('song id', song);
                const httpservice = new HTTPService()
                await httpservice.getTrackLyrics(song.item.id)
                .then(l => {
                  // console.log('l', l);
                  setLyrics(l)
                  // setLyrics(l.reduce((p, c) => ({
                  //   ...p,
                  //   [c.startTimeMs]: c.words
                  // }),{}))              
                })
    
                if (song.progress_ms && song.item.duration_ms) {
                  setnewTrackCountdown(song.item.duration_ms - song.progress_ms - 5000)
                }
                
                
    
              // if (song.item.id) {
              //   const ds = new DataService()
              //   ds.getSpotifyCanvas(token, song.item.id, song.item.uri)
              //   .then(r => console.log(r.text()))
              //   .catch(e => console.log(e))
              // }          
    
              } else {
                setnewTrackCountdown(-1)
              }
    
            })
    
          }, newTrackCountdown);
        }
    
        return (() => {
          if (newTrackTimer.current) clearTimeout(newTrackTimer.current)
        })
    
      }, [newTrackCountdown, token]);


      useEffect(() => {

        if (spotifyToken && spotifyToken.exists()) {
          setToken(spotifyToken.data().token)
          setnewTrackCountdown(1000)
        };
    
      }, [spotifyToken]);
    
      useEffect(() => {

        const now = DateTime.local()
        setTimeout(() => {
          setInterval(() => {
            if (!currentDay.hasSame(DateTime.local(), 'day')) {
              window.location.reload()
            }
          }, 30 * 60 *  1000);
    
        }, now.current ? now.current.endOf('hour').diffNow().milliseconds : 1000); 
      }, [currentDay]);

      
  const trackinfo = useMemo(() => {
    if (track && track.item) return (<TrackInfo track={track.item} start={track.progress_ms} duration={track.item.duration_ms} lyrics={lyrics} />)

    return (<Iconify icon="logos:spotify-icon" sx={{ width: '24vh', height: '24vh' }}  />)
  
  
  }, [lyrics, track])

  
  const SpotifyLogin = () => (<Button className="btn-spotify" color='success' onClick={async () => {

    const scope = "streaming user-read-email user-read-private user-read-playback-state"

    const state = generateRandomString(16);

    const authQueryParameters = new URLSearchParams({
      response_type: "code",
      client_id: '70d425d967b841e4947bf0da068f34d8',
      scope,
      redirect_uri: isLocalhost
      ? `${NGROK_REDIRECT_URL}/flexitarmstrong/us-central1/api/auth/callback`
      : "https://us-central1-flexitarmstrong.cloudfunctions.net/api/auth/callback",
      state
    })

    console.log(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);
    window.open(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);


  }}>
                <Iconify icon="logos:spotify-icon" sx={{ width: '24vh', height: '24vh' }}  />
  </Button>
)

    
    return  (token && newTrackCountdown >= 0) ? trackinfo : <SpotifyLogin /> 

}


// const ds = new DataService()
// ds.getSpotifyFeatueres({trackname: [song.item.name, song.item.artists[0].name].join(" by "), trackid: song.item.id, token})
